export default __webpack_public_path__ + "static/media/011-cola.3cdb5dc0.svg";